if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Update template
         *
         * @param container - container of updating elements
         * - Required attribute [data-json-url] on container
         *
         * Pair elements to data using [data-update-template="xpath.to.json.field"] on child nodes of container
         * Templates update on specific triggers marked by [data-update-template-trigger] attribute
         *
         * use [data-update-template-condition="xpath.to.json.field"] attribute on a child node to only show this node when specific field is present in json response
         *
         * - Add attribute [data-update-template-wait-for="name-of-event"] to wait with update until specified (custom) event is triggered
         */
        ZZ.UpdateTemplate = function(container) {
            var base = this;
            base.container = container;
            base.updateElements = base.container.find("[data-update-template]");
            base.updateTriggers = base.container.find(
                "[data-update-template-trigger]"
            );
            base.conditionals = base.container.find(
                "[data-update-template-condition]"
            );
            base.jsonUrl = base.container.attr("data-json-url");

            base.ajaxPromise = Promise.resolve();

            base.assignListeners();
        };

        ZZ.UpdateTemplate.prototype = {
            assignListeners: function() {
                var base = this,
                    curTrigger;

                base.updateTriggers.on("change.UpdateTemplate", function(e) {
                    curTrigger = $(this);

                    // if data-template-update-wait-for is specified, wait for the trigger of custom event and then update
                    if (
                        typeof curTrigger.attr(
                            "data-update-template-wait-for"
                        ) !== "undefined"
                    ) {
                        var event = curTrigger.attr(
                            "data-update-template-wait-for"
                        );
                        curTrigger.one(event, function() {
                            base.update();
                        });
                    } else {
                        base.update();
                    }
                });
            },

            update: function() {
                var base = this,
                    url = base.jsonUrl,
                    data = base.container.find(":input").serialize(),
                    method = base.container.attr("data-method") || "GET";

                // add relevant values to data, even if they are disabled / exlude unchecked checkboxes
                var disabledTriggerInputs = base.container
                        .find("[data-update-template-trigger]:input:disabled")
                        .not("input[type=checkbox]:not(:checked)"),
                    curInput;
                disabledTriggerInputs.each(function() {
                    curInput = $(this);
                    data +=
                        "&" +
                        encodeURIComponent(curInput.attr("name")) +
                        "=" +
                        encodeURIComponent(disabledTriggerInputs.val());
                });

                // add unique number to prevent cashing
                url += base.jsonUrl.indexOf("?") === -1 ? "?" : "&";
                url += new Date().valueOf();

                var ajaxRequestPromise = base.ajaxRequest({
                    url: url,
                    type: method,
                    data: data,
                    dataType: "json",
                    redirLogout: true /* redirect in case logged out (redirect-proxy.js) */
                });

                base.ajaxPromise = base.ajaxPromise
                    .then(function() {
                        return ajaxRequestPromise;
                    })
                    .then(function(data) {
                        base.processData(data);
                    })
                    .catch(function(e) {
                        console.log(e);
                    });
            },

            ajaxRequest: function(options) {
                return new Promise((resolve, reject) => {
                    $.ajax(options)
                        .done(resolve)
                        .fail(reject);
                });
            },

            // map data on elements
            processData: function(json) {
                var base = this,
                    value,
                    updatePath,
                    xpath,
                    curItem,
                    conditional;

                // update items on page
                base.updateElements.each(function(index, item) {
                    curItem = $(item);
                    updatePath = curItem.attr("data-update-template");
                    xpath = updatePath.split(".");
                    value = base.getValue(json, xpath);

                    if (typeof value !== "undefined" && value !== null) {
                        if (curItem.is("select")) {
                            base.updateSelectbox(curItem, value);
                        } else if (curItem.is(":input")) {
                            curItem.val(value);
                        } else {
                            curItem.text(value);
                        }
                    }
                });

                // show/hide conditional items
                base.conditionals.each(function(index, item) {
                    curItem = $(item);
                    updatePath = curItem.attr("data-update-template-condition");
                    if (typeof updatePath !== "undefined") {
                        xpath = updatePath.split(".");
                        value = base.getValue(json, xpath);

                        if (
                            base.isCurrentElementTargetGroupDiscountAndChecked(
                                curItem
                            )
                        ) {
                            value = curItem.attr(
                                "data-trigger-target-group-discount-show-on-selection"
                            );
                        }

                        if (
                            typeof value === "undefined" ||
                            value === null ||
                            value === false ||
                            value === "false"
                        ) {
                            curItem.hide();
                        } else {
                            curItem.show(150);
                        }
                    }
                });
            },

            isCurrentElementTargetGroupDiscountAndChecked: function(curItem) {
                return (
                    curItem.attr(
                        "data-trigger-target-group-discount-show-on-selection"
                    ) &&
                    $("[data-target-group-discount-checkbox]").is(":checked")
                );
            },

            //update selectbox
            updateSelectbox: function(selectbox, options) {
                selectbox.empty();
                $.each(options, function(key, value) {
                    selectbox.append(
                        $("<option></option>")
                            .attr("value", value.value)
                            .attr("selected", value.selected)
                            .text(value.option)
                    );
                });
            },
            // get value from json, given a certain xpath
            // @param xpath: array of path steps e.g. ['animal', 'cat', 'whisker'] for xpath animal.cat.whisker
            getValue: function(json, xpath, index) {
                var base = this,
                    curIndex = index || 0,
                    curValue;

                if (typeof json === "undefined") {
                    return null;
                }

                curValue = json[xpath[curIndex]];
                if (curIndex === xpath.length - 1) {
                    return curValue;
                } else {
                    return base.getValue(curValue, xpath, ++curIndex);
                }
            }
        };
    })(jQuery);
}
